const TextBox = ({ name, value, placeholder = '',  unit = '', onChange = null, requiredMessage = null, onlyDigits = false, className = null, onBlur = null}) => {
  const handleChange = (e) => {
    let val = e.target.value;
    if (onlyDigits) {
      val = val.replace(/\D/g, '');
    }
    onChange
      ? onChange({ ...e, target: { ...e.target, name: name, value: val } })
      : () => {};
  };

  return (
  <div className={unit? "input-group":"rel"}>
    <input 
      className={"form-control" + (className ? ' ' + className : '')}
      id={name} 
      name={name} 
      type="text" 
      value={value} 
      placeholder={placeholder} 
      onChange={onlyDigits ? handleChange : onChange ?? (() => {})} 
      required
      onBlur={onBlur}
      data-val="true" 
      data-val-required={requiredMessage} 
      inputMode={onlyDigits ? 'numeric' : undefined}
      pattern={onlyDigits ? '\\d*' : undefined}
    />
    {unit && <span className="input-group-text">{unit}</span>}
    <span className="text-danger field-validation-valid" data-valmsg-for={name} data-valmsg-replace="true"></span>
  </div>
  );
};

export default TextBox;
